import ItemViewState from '../store/schema/ItemViewState';
import InfoBarMessageViewStateCreator from 'owa-info-bar/lib/schema/InfoBarMessageViewStateCreator';
import { action } from 'satcheljs/lib/legacy';
import addInfoBarMessage from 'owa-info-bar/lib/actions/addInfoBarMessage';

const addInfoBarMessageInReadingPane = action('addInfoBarMessageInReadingPane')(
    function addInfoBarMessageInReadingPane(
        viewState: ItemViewState,
        messageId: string,
        infoBarMessageViewStateCreator?: InfoBarMessageViewStateCreator
    ) {
        addInfoBarMessage(viewState, messageId, viewState.itemId, infoBarMessageViewStateCreator);
    }
);

export default addInfoBarMessageInReadingPane;
